import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import { Message, List } from "semantic-ui-react";
import {
  ModalTemplate,
  Button,
  Loading,
  ReduxFormHiddenInput,
} from "components";

import * as common from "libs/commonFunc";

import styles from "../../../style/modal.css";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

class ModalExamDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      isModal,
      onExamResend,
      onToggleModal,
      selectedExam,
    } = this.props;
    console.log(isModal, "tetete");
    if (!selectedExam) {
      return null;
    }
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx("modal-examDelete-area", "common-content")}
        visible={visible}
        onToggleModal={onToggleModal}
        header={
          isModal === "failTargetExamResend"
            ? defineMessages(
                formatMessage({
                  id: "ExamSummaryItem_23",
                  defaultMessage: "실패한 메일 재전송",
                })
              )
            : defineMessages(
                formatMessage({
                  id: "ModalExamResend_1",
                  defaultMessage: "훈련메일 재전송",
                })
              )
        }
        buttons={
          <div className={cx("inline-block")}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal("");
              }}
            >
              {defineMessages(
                formatMessage({
                  id: "ModalExamResend_3",
                  defaultMessage: "취 소",
                })
              )}
            </Button>
            <Button
              className={cx("brand-button")}
              disabled={isClicked}
              loading={isClicked}
              onClick={() => onExamResend(isModal)}
            >
              {defineMessages(
                formatMessage({
                  id: "ModalExamResend_4",
                  defaultMessage: "재전송",
                })
              )}
            </Button>
          </div>
        }
      >
        <div className={cx("message-header")}>
          {defineMessages(
            formatMessage({
              id: "ModalExamResend_2",
              defaultMessage: "훈련메일을 다시 보내시겠습니까?",
            })
          )}
        </div>
      </ModalTemplate>
    );
  }
}
ModalExamDelete.propTypes = {
  visible: PropTypes.bool,
  onDeleteExam: PropTypes.func,
  onToggleModal: PropTypes.func,
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      examNo: props.selectedExam.get("examNo"),
      examName: props.selectedExam.get("examName"),
    },
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: "formExamResend", enableReinitialize: true })(
    injectIntl(ModalExamDelete)
  )
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalExamResend.js